/*
*
* File JS Principale
*
*/


// IMPORT JQUERY
//--------------------------------------------------------------------//

import $ from 'jquery';

// IMPORT SCSS PER LA COMPILAZIONE
//--------------------------------------------------------------------//

import '../scss/app.scss';

//--------------------------------------------------------------------//


// IMPORT LIBRERIE ESTERNE
//--------------------------------------------------------------------//

import WebFont from 'webfontloader';
import 'bootstrap-italia';

//--------------------------------------------------------------------//

// LOAD FONTS
//--------------------------------------------------------------------//

WebFont.load
({
    google: {
        families: ['Titillium Web:300,400,600,700']
    }
});

//--------------------------------------------------------------------//



// IMPORT FILE JS PER COMPONENTI
//--------------------------------------------------------------------//

// import initRatings from './components/rating'; //js rating spostato su plugin im-comune-rating
import smoothScroll from './smooth-scroll';
//--------------------------------------------------------------------//


// INIT COMPONENTI
//--------------------------------------------------------------------//

// initRatings();

//fix header bug:
const navLinks = document.querySelectorAll('#index-page .nav-item')
const backButton = document.getElementById('back-button-bs'); // Assicurati che questo ID corrisponda al tuo pulsante di back

if(navLinks && backButton)
{
    navLinks.forEach((link) => {
        link.addEventListener('click', () => {
            backButton.click(); // Simula un click sul pulsante di back
        });
    });
}

//Fix header v2:

const burgerHeader = document.querySelector('[data-im-header]');
const closeButton = document.querySelector('#nav1 .close-div .close-menu');

if(burgerHeader)
{
    burgerHeader.addEventListener('click', (e) => {
        burgerHeader.classList.add('im-header-open');
    });

    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && burgerHeader.classList.contains('im-header-open')) {
            if (closeButton) {
                closeButton.click();
            }
        }
    });
    
}



//--------------------------------------------------------------------//

// IMPORT FILE JS PER PAGINE
//--------------------------------------------------------------------//

import initSinglePages from './pages/single';

//--------------------------------------------------------------------//


// INIT PAGINE
//--------------------------------------------------------------------//

initSinglePages();

//--------------------------------------------------------------------//
